// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"4e5f965b","92":"164d887b","307":"32bff2ff","532":"164d887b"}[chunkId] + ".chunk.css";
};